import { useSnackbar, VariantType } from 'notistack'
import { ReactNode } from 'react'

export const useCustomSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const openSnackbar = (message: ReactNode, variant: VariantType) => {
    enqueueSnackbar(message, {
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'top',
      },
      autoHideDuration: 6000,
      variant,
    })
  }

  return { closeSnackbar, openSnackbar }
}
